import React, { useState, Fragment } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = ['Impacto', 'Alianzas'];
  const scrollToSection = (sectionId: string) => {
    const id = sectionId.toLowerCase();
    setMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      // wait for home to render before scrolling
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
      return;
    }
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <div onClick={() => navigate('/venezuela-emergencia')} role="button" tabIndex={0} onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') navigate('/venezuela-emergencia');
    }} className="mp-emg-alert-banner sticky top-0 z-[60]" style={{
      background: '#CC0000',
      color: 'white',
      fontSize: '13px',
      textAlign: 'center',
      padding: '8px 16px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px'
    }} data-id="element-128">
        🚨 EMERGENCIA VENEZUELA · Ayuda ahora
      </div>
      <nav className="mp-navbar sticky top-0 left-0 right-0 z-50 flex items-center" style={{
      minHeight: '85px',
      background: '#ffffff',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
      paddingLeft: '32px',
      paddingRight: '32px'
    }} data-id="element-129">
        <div className="max-w-7xl mx-auto w-full" data-id="element-130">
          <div className="flex justify-between items-center" data-id="element-131">
            <div className="flex-shrink-0" data-id="element-132">
              <Link to="/" data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/5M6X1iYfRiLeS5bu5erw4R/3.png" alt="Pancita Feliz Foundation" className="mp-navbar-logo object-contain block" style={{
                width: '160px',
                height: 'auto',
                minWidth: '160px',
                marginRight: '32px',
                objectFit: 'contain'
              }} data-id="element-134" />
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-6" data-id="element-135">
              {menuItems.map(item => <Fragment key={item} data-id="element-136">
                  <button onClick={() => scrollToSection(item)} className="text-sm text-dark hover:text-primary transition-colors font-medium" data-id="element-137">
                    {item}
                  </button>
                  {item === 'Alianzas' && <>
                      <Link to="/quiero-ser-aliado" className="text-sm text-dark hover:text-primary transition-colors font-medium" data-id="element-138">
                        Ser Aliado
                      </Link>
                      <Link to="/venezuela-emergencia" className="mp-nav-emg-link" style={{
                  color: '#CC0000',
                  fontWeight: 700,
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '6px 12px',
                  borderRadius: '20px',
                  border: '1.5px solid #CC0000',
                  whiteSpace: 'nowrap',
                  textDecoration: 'none',
                  transition: 'all 0.2s'
                }} data-id="element-139">
                        <div style={{
                    width: '8px',
                    height: '8px',
                    background: '#CC0000',
                    borderRadius: '50%',
                    animation: 'navPulse 1.5s infinite'
                  }} data-id="element-140" />
                        Emergencia Venezuela
                      </Link>
                    </>}
                </Fragment>)}
              <Link to="/solicitar-ayuda" className="border-2 border-primary text-primary text-sm font-semibold transition-colors hover:bg-primary hover:text-white" style={{
              borderRadius: '25px',
              padding: '8px 20px'
            }} data-id="element-141">
                Solicitar Ayuda
              </Link>
              <Link to="/donar" className="bg-primary text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-primary/90 transition-colors" data-id="element-142">
                Donar Ahora
              </Link>
            </div>

            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 rounded-lg hover:bg-gray-100" aria-label="Toggle menu" data-id="element-143">
              {mobileMenuOpen ? <XIcon className="h-6 w-6 text-dark" data-id="element-144" /> : <MenuIcon className="h-6 w-6 text-dark" data-id="element-145" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && <div className="md:hidden bg-white border-t absolute top-full left-0 right-0" data-id="element-146">
            <div className="px-4 py-4 space-y-3" data-id="element-147">
              {menuItems.map(item => <Fragment key={item} data-id="element-148">
                  <button onClick={() => scrollToSection(item)} className="block w-full text-left px-4 py-2 text-dark hover:bg-gray-50 rounded-lg font-medium" data-id="element-149">
                    {item}
                  </button>
                  {item === 'Alianzas' && <>
                      <Link to="/quiero-ser-aliado" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-2 text-dark hover:bg-gray-50 rounded-lg font-medium" data-id="element-150">
                        Ser Aliado
                      </Link>
                      <Link to="/venezuela-emergencia" onClick={() => setMobileMenuOpen(false)} style={{
                color: '#CC0000',
                fontWeight: 700,
                padding: '12px 16px',
                borderBottom: '1px solid #eee',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '15px',
                textDecoration: 'none'
              }} data-id="element-151">
                        <div style={{
                  width: '8px',
                  height: '8px',
                  background: '#CC0000',
                  borderRadius: '50%',
                  animation: 'navPulse 1.5s infinite'
                }} data-id="element-152" />
                        Emergencia Venezuela
                      </Link>
                    </>}
                </Fragment>)}
              <Link to="/solicitar-ayuda" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center border-2 border-primary text-primary px-6 py-2.5 font-semibold transition-colors hover:bg-primary hover:text-white" style={{
            borderRadius: '25px'
          }} data-id="element-153">
                Solicitar Ayuda
              </Link>
              <Link to="/donar" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center bg-primary text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-primary/90 transition-colors" data-id="element-154">
                Donar Ahora
              </Link>
            </div>
          </div>}
      </nav>
    </>;
}